<!-- components/Profile.vue -->
<template>
    <div class="row">
      <div class="col-12">
        <div class="card position-relative border-0 bg-body-tertiary">
          <div class="card-body d-flex flex-col flex-md-row align-items-center gap-3" v-if="data.avatar || data.firstname || data.lastname">
            <div v-if="data.avatar" class="border border-1 border-secondary rounded-circle overflow-hidden" style="width: 100px; height: 100px;">
              <img :src="data.avatar" alt="Avatar" class="img-fluid object-fit-cover h-100 w-100" />
            </div>  
            <div class="lh-xs d-none d-md-block">
              <h5 class="card-title mb-0 lh-sm">{{ data.firstname + ' ' + data.lastname }}</h5>
              <span class="text-muted font-light fs-xs d-block">Rider</span>
              <span class="font-light text-muted fs-xs d-block">{{ data.country + ', ' + data.state }}</span>
            </div>
          </div>
          <div class="position-absolute bottom-0 end-0 text-start p-3">
            <h6 class="text-uppercase text-muted fs-xs mb-1">est. earnings</h6>
            <span class="text-black font-xs fs-xs d-block">
              <CurrencyFormatter :amount="data.income" currency="NGN" locale="en-NG" />
            </span>
          </div>
        </div>
      </div>
  
      <!-- Personal Info -->
      <div class="col-12 mt-4">
        <span class="text-black fs-6 p-2 rounded-2 text-uppercase bg-warning-subtle">PERSONAL INFORMATION</span>
      </div>
      <div class="col-12 col-md-6" v-for="(value, label) in personalInfo" :key="label">
        <div class="lh-sm">
          <h3 class="font-light text-muted fs-xs mb-0">{{ label }}</h3>
          <p class="text-black font-bold fs-sm">{{ value || '-' }}</p>
        </div>
      </div>
  
      <!-- Address Info -->
      <div class="col-12 mt-4">
        <span class="text-black fs-xs text-uppercase bg-warning-subtle p-2 rounded-2">Address</span>
      </div>
      <div class="col-12 col-md-6" v-for="(value, label) in addressInfo" :key="label">
        <div class="lh-sm">
          <h3 class="font-light text-muted fs-xs mb-0">{{ label }}</h3>
          <p class="text-black font-bold fs-sm">{{ value || '-' }}</p>
        </div>
      </div>
  
      <!-- Identification -->
        <div class="col-12 mt-4">
            <span class="text-black fs-xs bg-warning-subtle text-uppercase p-2 rounded-2">Identification</span>
        </div>
        <div
        class="col-12 col-md-6 mb-2"
        v-for="(image, label) in identificationImages"
        :key="label"
        >
        <div class="lh-sm" v-if="image">
            <h3 class="font-light text-muted fs-xs mb-0">{{ label }}</h3>
            <div class="p-2 overflow-hidden" style="height:200px;">
            <img :src="image" class="img-thumbnail w-100 h-100 object-fit-contain" style="object-position: center;" />
            </div>
        </div>
    </div>

    </div>
  </template>
  
  <script lang="ts">
  import { Component, Prop, Vue, toNative } from 'vue-facing-decorator'
  import CurrencyFormatter from './CurrencyFormatter.vue'
  
  @Component({ components: { CurrencyFormatter } })
  class Profile extends Vue {
    @Prop({ required: true }) data!: Record<string, any>
  
    get personalInfo() {
      return {
        Firstname: this.data.firstname,
        Lastname: this.data.lastname,
        'Email Address': this.data.email,
        'Phone Number': this.data.phone
      }
    }
  
    get addressInfo() {
      return {
        Street: this.data.street,
        'Bank Verification Number': this.data.bvn,
        State: this.data.state,
        Country: this.data.country
      }
    }
  
    get identificationImages() {
      return {
        'ID Card': this.data.id_card,
        'Proof of Ownership Document': this.data.owner_doc,
        Avatar: this.data.avatar,
        Signature: this.data.signature,
        Idemnity: this.data.idemnity,
        Agreement: this.data.agreement
      }
    }
  }
  
  export default toNative(Profile)
  </script>
  